export const MEMBER_CTO_MENU = {
  菜单名称: '会员解封',
  菜单图标: 'el-icon-user',
  ID: 4,
  菜单路由: '/memberCto',
}

export const CACHE_CLEAR_MENU = {
  菜单名称: '缓存清理',
  菜单图标: 'el-icon-delete',
  ID: 6,
  菜单路由: '/cacheClear',
}

export const ORDER_QUERY_MENU = {
  菜单名称: '订单查询',
  菜单图标: 'el-icon-s-order',
  ID: 7,
  菜单路由: '/orderQuery',
}

export const FINANCE_MANAGE_MENU = {
  菜单名称: '财务管理',
  菜单图标: 'el-icon-money',
  ID: 8,
  菜单路由: '/financeManage',
}

export const ALL_ADMIN_MENUS = [
  { 菜单名称: '报表', 菜单图标: 'el-icon-document', ID: 1, 菜单路由: '/report' },
  { 菜单名称: '咖啡统计', 菜单图标: 'el-icon-coffee', ID: 2, 菜单路由: '/coffee' },
  { 菜单名称: '账号', 菜单图标: 'el-icon-s-custom', ID: 3, 菜单路由: '/account' },
  MEMBER_CTO_MENU,
  { 菜单名称: '问卷统计', 菜单图标: 'el-icon-edit-outline', ID: 5, 菜单路由: '/questionnaireStats' },
  { 菜单名称: '意见收集统计', 菜单图标: 'el-icon-chat-dot-square', ID: 9, 菜单路由: '/suggestionStats' },
]

const CUSTOMER_SERVICE_RESTRICTED_ROUTES = ['/report', '/coffee', '/account', '/cacheClear', '/orderQuery', '/financeManage']
const ADMIN_ONLY_ROUTES = ['/cacheClear', '/orderQuery', '/financeManage']

// 意见收集统计页（/suggestionStats）专属账号：合作人员[0].隶属ID
const SUGGESTION_COMPANY_ID = 'bhkj-12345'

export function parseLoginTopic(data) {
  const topic = data.Topic
  if (topic == null || topic === '') return ''
  if (typeof topic === 'object' && Array.isArray(topic.data)) {
    return topic.data[0] || ''
  }
  return String(topic)
}

export function isCustomerService() {
  return window.sessionStorage.getItem('topic') === 'customer_service'
}

export function isAdminUser() {
  return window.sessionStorage.getItem('isAdmin') === '1'
}

/** 登录后判断：合作人员[0].隶属ID === bhkj-12345 */
export function isSuggestionCooperator() {
  return window.sessionStorage.getItem('companyId') === SUGGESTION_COMPANY_ID
}

export function getAdminMenuList() {
  if (isCustomerService()) {
    return [MEMBER_CTO_MENU]
  }
  if (isAdminUser()) {
    return [...ALL_ADMIN_MENUS, CACHE_CLEAR_MENU, ORDER_QUERY_MENU, FINANCE_MANAGE_MENU]
  }
  return ALL_ADMIN_MENUS
}

export function isCustomerServiceRestrictedRoute(path) {
  return CUSTOMER_SERVICE_RESTRICTED_ROUTES.includes(path)
}

export function isAdminOnlyRoute(path) {
  return ADMIN_ONLY_ROUTES.includes(path)
}
